var render, staticRenderFns
import script from "./ui-loading-global.vue?vue&type=script&lang=js"
export * from "./ui-loading-global.vue?vue&type=script&lang=js"
import style0 from "./ui-loading-global.vue?vue&type=style&index=0&id=3046354c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports